import httpService from "./httpService";
import utils from "./utils";

export default {
  listChoTiepNhan2(form, pageable) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge(form, pageable);
    return httpService.get("incomingDoc/listChoTiepNhan", {params: params});
  },

  listChoTiepNhan(
    usingAdvanceSearch,
    keyword,
    form,
    pageable,
    fromDocDate,
    toDocDate
  ) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge(
      utils.merge(
        {
          usingAdvanceSearch: usingAdvanceSearch,
          keyword: keyword,
          fromDocDate: fromDocDate,
          toDocDate: toDocDate
        },
        form
      ),
      pageable
    );

    return httpService.get("incomingDoc/listChoTiepNhan", {params: params});
  },

  ccVanBan(form) {
    return httpService.post("/vbIncomingProcess/ccVanBan", form);
  },

  countChoTiepNhan(usingAdvanceSearch, keyword, form, fromDocDate, toDocDate) {
    let params = utils.merge(
      {
        usingAdvanceSearch: usingAdvanceSearch,
        keyword: keyword,
        fromDocDate: fromDocDate,
        toDocDate: toDocDate
      },
      form
    );

    return httpService.get("/incomingDoc/countChoTiepNhan", {params: params});
  },

  // listDaXuLyVT(form, pageable) {
  //   let params = utils.merge(form, utils.initPageableParams(pageable));
  //   return httpService.get("incomingDoc/listDaXuLyVT", {params: params});
  // },

  createIncomingDoc(form) {
    return httpService.post("incomingDoc/createIncomingDoc", form);
  },

  findById(id, subDocId) {
    return httpService.get(`/incomingDoc/${id}`, {
      params: {subDocId: subDocId}
    });
  },

  findAll(example, pageable) {
    let params = utils.merge(example, utils.initPageableParams(pageable));
    return httpService.get(`/incomingDoc`, {params: params});
  },

  thuHoi(form, id) {
    return httpService.put(`incomingDoc/${id}/thuHoi`, form);
  },

  tuChoiTiepNhan(form, id) {
    return httpService.put(`incomingDoc/${id}/tuChoiTiepNhan`, form);
  },

  findAllByVbOutgoingDocId(vbOutgoingDocId) {
    let params = {vbOutgoingDocId: vbOutgoingDocId};
    return httpService.get(`/incomingDoc`, {params: params});
  },

  deleteForVanThu(id) {
    return httpService.delete(`/incomingDoc/${id}/deleteForVanThu`);
  },
};



// WEBPACK FOOTER //
// ./src/services/incomingDocService.js